import React from 'react'
import {PageTitle} from '../../../_metronic/layout/core'
import {Navigate, Route, Routes} from 'react-router-dom'
import ModifPrixAddPage from './ModifPrixAddPage'
import ModifPrixEditPage from './ModifPrixEditPage'
import {ModifPrixListPage} from './ModifPrixListPage'

const ModifPrixWrapper = () => {
  return (
    <>
      <PageTitle breadcrumbs={[]}>Modification prix</PageTitle>
      <Routes>
        <Route path='/liste' element={<>{<ModifPrixListPage />}</>} />
        <Route
          path='/ajouter'
          element={
            <>
              <ModifPrixAddPage />
            </>
          }
        />
        <Route
          path='/:prixId/modifier'
          element={
            <>
              <ModifPrixEditPage />
            </>
          }
        />

        <Route index element={<Navigate to='/modif-prix/liste' />} />
      </Routes>
    </>
  )
}

export {ModifPrixWrapper}
